// 常量采⽤全⼤写单词，单词之间使⽤‘_’拼接

//媒体
export const MEDIA = [{
    mainBjColor:'#242734',                      //背景颜色
    chooseColor:'#2196F3',                      //选中颜色,字体颜色,线条颜色
    lefSecLevBjColor:'#1E222C',                 //左侧二级选中背景颜色
    fourLevBjColor:'rgba(33,150,243,.2)',       //四级选中背景颜色
    firFontColor:'rgba(0, 0, 0, 0.45)',         //顶部一级字体颜色  
    fourChooseFontColor:'#2196F3',              //四级选中字体颜色
    fourFontColor:'rgba(0, 0, 0, 0.65)',        //四级字体颜色
    fontColor:'#ffffff',                        //左侧字体颜色
    tabColor:'#2196F3',                         //tab字体颜色
},{
    mainBjColor:'#026ABD',                      //背景颜色
    chooseColor:'#2196F3',                      //选中颜色,字体颜色,线条颜色
    lefSecLevBjColor:'#067DDB',                 //左侧二级选中背景颜色
    fourLevBjColor:'rgba(33,150,243,.2)',       //四级选中背景颜色
    firFontColor:'rgba(0, 0, 0, 0.45)',         //顶部一级字体颜色  
    fourChooseFontColor:'#1890FF',              //四级选中字体颜色
    fourFontColor:'rgba(0, 0, 0, 0.65)',        //四级字体颜色
    fontColor:'#ffffff',                        //左侧字体颜色
    tabColor:'#1890FF',                         //tab字体颜色
},{
    mainBjColor:'#464D75',                      //背景颜色
    chooseColor:'#5374E4',                      //选中颜色,字体颜色,线条颜色
    lefSecLevBjColor:'#454E7B',                 //左侧二级选中背景颜色
    fourLevBjColor:'rgba(221,227,250,.2)',      //四级选中背景颜色
    firFontColor:'rgba(0, 0, 0, 0.45)',         //顶部一级字体颜色  
    fourChooseFontColor:'#FF9F24',              //四级选中字体颜色
    fourFontColor:'#778CA2',                    //四级字体颜色
    fontColor:'#ffffff',                        //左侧字体颜色
    tabColor:'#FF9F24',                         //tab字体颜色
}]

//政务
export const GOVERNMENT = [{
    mainBjColor:'#242734',                      //背景颜色
    chooseColor:'#F44336',                      //选中颜色,字体颜色,线条颜色
    lefSecLevBjColor:'#1E222C',                 //左侧二级选中背景颜色
    fourLevBjColor:'#FFEBEE',                   //四级选中背景颜色
    firFontColor:'rgba(0, 0, 0, 0.45)',         //顶部一级字体颜色  
    fourChooseFontColor:'#F44336',              //四级选中字体颜色
    fourFontColor:'rgba(0, 0, 0, 0.65)',        //四级字体颜色
    fontColor:'#ffffff',                        //左侧字体颜色
    tabColor:'#F44336',                         //tab字体颜色
},{
    mainBjColor:'#a23535',                      //背景颜色
    chooseColor:'#cd4545',                      //选中颜色,字体颜色,线条颜色
    lefSecLevBjColor:'#b73d3d',                 //左侧二级选中背景颜色
    fourLevBjColor:'#f5dada',                   //四级选中背景颜色
    firFontColor:'rgba(0, 0, 0, 0.45)',         //顶部一级字体颜色  
    fourChooseFontColor:'#cd4545',              //四级选中字体颜色
    fourFontColor:'#595959',                    //四级字体颜色
    fontColor:'#ffffff',                        //左侧字体颜色
    tabColor:'#cd4545',                         //tab字体颜色
}]

//通用
export const CURRENCY = [{
    mainBjColor:'#FFFFFF',                      //背景颜色
    chooseColor:'#EF6C00',                      //选中颜色,字体颜色,线条颜色
    lefSecLevBjColor:'#F5F5F5',                 //左侧二级选中背景颜色
    fourLevBjColor:'#FFECDB',                   //四级选中背景颜色
    firFontColor:'rgba(0, 0, 0, 0.45)',         //顶部一级字体颜色  
    fourChooseFontColor:'#EF6C00',              //四级选中字体颜色
    fourFontColor:'rgba(0, 0, 0, 0.65)',        //四级字体颜色
    fontColor:'rgba(51, 51, 51, 0.65)',        //左侧字体颜色
    tabColor:'#EF6C00',                         //tab字体颜色
}]
